module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-3.60bd699f.webp";